// extracted by mini-css-extract-plugin
module.exports = {"subscriptionWrapper":"o5gBW","subscriptionButton":"XcgX1","disabled":"X87vr","subscriptionButtonv2":"ffcbB"};